import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Typography } from '@mui/material'

const stylesSx = { mt: 0.5, display: 'block'}
const buttonSx = { cursor: 'pointer', fontSize: '16px', fontWeight: 700, borderRadius: '25px' }
export default function SubmitButtonWithStatus({
  ButtonComponent = Button,
  label = 'Submit',
  loadingLabel = 'Submitting…',
  disabled = false,
  disabledReason = '',
  loading = false,
  buttonProps = {},
}) {
  const isDisabled = disabled || loading
  return (
    <Box>
      <ButtonComponent
        {...buttonProps}
        disabled={isDisabled}
        aria-disabled={isDisabled}
        aria-busy={loading ? true : undefined}
        styles={buttonSx}
      >
        {loading ? loadingLabel : label}
      </ButtonComponent>
      <Box role="status" aria-live="polite">
        {isDisabled && !loading && disabledReason ? (
          <Typography variant="body1" color="text.secondary" sx={stylesSx}>
            {disabledReason}
          </Typography>
        ) : null}
      </Box>
    </Box>
  )
}

SubmitButtonWithStatus.propTypes = {
  ButtonComponent: PropTypes.elementType,
  label: PropTypes.string,
  loadingLabel: PropTypes.string,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string,
  loading: PropTypes.bool,
  buttonProps: PropTypes.object,
}
